import { ComponentRef, ViewContainerRef } from '@angular/core';
import { UsernameFormNoRecaptchaComponent } from './username-form-no-recaptcha.component';


class UsernameNoRecaptchaFormSession implements com.ts.mobile.sdk.UIFormSession{
  clientContext: object;
  actionContext: object;
  formId: string;
  payload: any;
  subflow: string;

  submitHandler: any;
  submitBlock: (payload: object) => void;
  // currentHandler: (response: com.ts.mobile.sdk.InputOrControlResponse<any>) => void;
  viewContainerRef: ViewContainerRef;
  usernameFormNoRecaptchaComponent: ComponentRef<UsernameFormNoRecaptchaComponent>;

  constructor(formId: string, payload: object) {

      this.formId = formId;
      this.payload = payload;
      this.subflow = this.payload.actions[0].subflow;
  }
  startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {

    this.clientContext = clientContext;
    this.actionContext = actionContext;
    this.viewContainerRef = (clientContext as any).viewContainerRef;

  }
  endSession(): void {

    // setTimeout(() => this.usernameFormSessionCompRef.instance.setErrorCode(), 100)
  }
  promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
    this.viewContainerRef.clear();

    this.usernameFormNoRecaptchaComponent = this.viewContainerRef.createComponent(UsernameFormNoRecaptchaComponent);
    this.usernameFormNoRecaptchaComponent.instance.onSubmitUserId = this.onSubmitUserData.bind(this);
    this.usernameFormNoRecaptchaComponent.instance.onForgotUserEmailSubmit = this.onForgotUsernameSubmit.bind(this);
    this.usernameFormNoRecaptchaComponent.instance.onRegisterClick = this.onRegisterClick.bind(this);
    this.usernameFormNoRecaptchaComponent.instance.onForgotUsernameAccountClick = this.onForgotUsernameAccountClick.bind(this);
    this.usernameFormNoRecaptchaComponent.instance.onVerifyUserEmailSubmit = this.onRegPendingVerifyEmail.bind(this);

    this.usernameFormNoRecaptchaComponent.instance.onForgotUsernameLinkClick = this.onForgotUsernameLinkSubmit.bind(this);
    this.usernameFormNoRecaptchaComponent.instance.onRegisterLinkClick = this.onRegisterLinkSubmit.bind(this);
    this.usernameFormNoRecaptchaComponent.instance.onForgotUsernameAccountLinkClick = this.onForgotUsernameAccountLink.bind(this);

    this.usernameFormNoRecaptchaComponent.instance.loginHint = this.subflow;

    const journeyPayload = this.payload as JourneyPayload;

    const action = journeyPayload.actions[0] as ActionsInPayload;

    this.usernameFormNoRecaptchaComponent.instance.flowFromPayload = 'login';

    return new Promise((resolve, reject) => {
      this.submitBlock = (payload: object) => {
        try {
          resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));

          this.submitBlock = null; // prevent reuse of a settled promise
        } catch (e) {

          console.error(e);
        }
      };
    });
  }
  onContinue(payload: object): void {

  }
  onError(payload: object): void {

    const url = this.clientContext['redirect_uri'];
    const state = this.clientContext['state'];

    const errorPayload = payload as JourneyPayload;

    if (errorPayload.code === 'BL02'){
      let appendChar = '?';
      if (url.includes('?'))
      {
         appendChar = '&';
      }
      window.location.href = url + appendChar + 'error=' + errorPayload.code + '&error_description=suspended' 
      + '&lang=' + this.clientContext['cookieService'].get('lang')
      + '&state=' + state;
    }
    else if (errorPayload.code === 'RC01'){
      this.clientContext['cookieService'].set('loginStoreErrorCode', errorPayload.code ? errorPayload.code : null, undefined, undefined, null, true, 'None');
    }
    else {
      this.clientContext['cookieService'].set('loginStoreErrorCode', errorPayload.code ? errorPayload.code : null, undefined, undefined, null, true, 'None');
    }
  }

  /** Non UIFormSession interface Functions */
  private onSubmitUserData(payload: object) {
    this.clientContext['cookieService'].delete('flow');
    this.clientContext['cookieService'].set('userEmail', payload['username'], undefined, undefined, null, true, 'None');

    const data = payload;
    this.submitBlock(data);
  }

  private onForgotUsernameSubmit(payload: object) {
    this.clientContext['cookieService'].set('flow', 'username', undefined, undefined, null, true, 'None');

    const data = payload;
    this.submitBlock(data);
  }

  private onRegPendingVerifyEmail(payload: object) {

    const data = payload;
    this.clientContext['cookieService'].delete('verifyEmail');
    this.submitBlock(data);
  }

  private onRegisterClick(brand: string){

    const url = this.clientContext['redirect_uri'];
    const state = this.clientContext['state'];
    const errorCode  = 'register';
    let appendChar = '?';
    if (url.includes('?'))
    {
       appendChar = '&';
    }
    window.location.href = url + appendChar + 'error=' + errorCode + '&error_description=register'
    + '&lang=' + this.clientContext['cookieService'].get('lang')
    + '&state=' + state;
  }

  private onForgotUsernameAccountClick(){
    const url = this.clientContext['redirect_uri'];
    const state = this.clientContext['state'];
    const errorCode  = 'forgotUsername';
    let appendChar = '?';
    if (url.includes('?'))
    {
       appendChar = '&';
    }
    window.location.href = url + appendChar + 'error=' + errorCode + '&error_description=forgotUsername'
    + '&lang=' + this.clientContext['cookieService'].get('lang')
    + '&state=' + state;
  }

  
   private onForgotUsernameLinkSubmit() {
    const data = {action: 'escape_forgotusername'};
    this.submitBlock(data);
  }

   private onRegisterLinkSubmit() {
    const data = {action: 'escape_register'};
    this.submitBlock(data);
  }

  private onForgotUsernameAccountLink(){
    const data = {action: 'escape_account-info-forgotusername'};
    this.submitBlock(data);
  }
}

interface JourneyPayload {
  actions: ActionsInPayload[];
  stat: string;
  code: string;
  flow: string;
}

interface ActionsInPayload {
  [key: string]: any;
}

export default UsernameNoRecaptchaFormSession;
